angular.module('rjmNg.controllers').controller 'noDashboardRouterCtrl', [
  "$location"
  "appRoute"
  "app"
  (
    $location
    appRoute
    app
  ) ->

    goToPersonalSettings = () ->
      $location.path appRoute("/settings/personal")

    if not (app.getClient().isImplemented or app.isSupportUserSession())
      $location.path appRoute("/settings/connection/")

    else
      goToPersonalSettings()

]
